var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.30227C12.5091 3.30227 14.5455 5.33864 14.5455 7.84773C14.5455 8.31136 14.4545 8.75682 14.3273 9.175L17.1091 11.9568C18.3727 10.8386 19.3727 9.43864 20 7.83864C18.4273 3.85682 14.5455 1.02955 10 1.02955C8.84546 1.02955 7.73636 1.21136 6.69091 1.54773L8.66364 3.52045C9.09091 3.39318 9.53636 3.30227 10 3.30227ZM1.55455 0.265909C1.2 0.620455 1.2 1.19318 1.55455 1.54773L3.34545 3.33864C1.87273 4.51136 0.7 6.05682 0 7.84773C1.57273 11.8386 5.45455 14.6659 10 14.6659C11.3818 14.6659 12.7 14.3932 13.9182 13.9205L16.3909 16.3932C16.7455 16.7477 17.3182 16.7477 17.6727 16.3932C18.0273 16.0386 18.0273 15.4659 17.6727 15.1114L2.84545 0.265909C2.49091 -0.0886364 1.90909 -0.0886364 1.55455 0.265909ZM10 12.3932C7.49091 12.3932 5.45455 10.3568 5.45455 7.84773C5.45455 7.14773 5.61818 6.48409 5.9 5.90227L7.32727 7.32955C7.3 7.49318 7.27273 7.66591 7.27273 7.84773C7.27273 9.35682 8.49091 10.575 10 10.575C10.1818 10.575 10.3455 10.5477 10.5182 10.5114L11.9455 11.9386C11.3545 12.2295 10.7 12.3932 10 12.3932ZM12.7 7.54773C12.5636 6.275 11.5636 5.28409 10.3 5.14773L12.7 7.54773Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideW);
export default __webpack_public_path__ + "static/media/HideW.e8478501f73f708445558f6b82b85573.svg";
export { ForwardRef as ReactComponent };